import { Star } from 'lucide-react';

const PALETTE = [
  'from-sky-500 to-blue-600', 'from-emerald-500 to-teal-600', 'from-orange-500 to-rose-500',
  'from-violet-500 to-fuchsia-600', 'from-amber-400 to-orange-500', 'from-cyan-500 to-sky-600',
  'from-lime-500 to-emerald-600', 'from-pink-500 to-rose-600',
];

export const favColor = (path) => PALETTE[[...path].reduce((a, c) => a + c.charCodeAt(0), 0) % PALETTE.length];

export function FavIcon({ fav, catalog, className = 'h-5 w-5' }) {
  const Icon = catalog[fav.path]?.icon || Star;
  return <Icon className={className} />;
}
